import { SCREEN } from '../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../common/selectCurrencyUnit/useFormatCurrency'

export const Price = ({ value, year, exchangeRateType }) => {
  const { formatCurrencyWithUnit } = useFormatCurrency(SCREEN.SUMMARY)
  return formatCurrencyWithUnit({ value, year, exchangeRateType })
}
